import React, { useState, useEffect } from 'react';
import { TranslateScope } from '@pegasus/translation';
import { TRANSLATION_SCOPE, FTW_RESET_PASSWORD_SUCCESS_COOKIE } from './constants';
import { useCustomerData } from './hooks';
import { isZalandoFashionStoreUser, hasCustomerData, isFacebookUser, isUserTransitioned, isDeprecationOverlayClosedByCustomer, getUrlSearchParam, track, TrackEvent, getCookie, deleteCookie, } from './helpers';
import { DeprecationWarningOverlay } from './DeprecationWarningOverlay';
import { updateUserAsTransitioned } from './service';
export const shouldHideModalOnPageLoad = (showModal) => !showModal;
const isCookieFTWResetPasswordHasValueRecover = () => getCookie(FTW_RESET_PASSWORD_SUCCESS_COOKIE) === 'recover';
export const doNotRenderIfNonTransitionedFacebookUserOfLoungeClosedModal = (isLoungeUserNotTransitioned) => {
    return isLoungeUserNotTransitioned && isDeprecationOverlayClosedByCustomer();
};
const getRedirectionUrlPath = (path) => {
    const redirectPathFromUrl = getUrlSearchParam('redirectPath');
    if (redirectPathFromUrl) {
        path = redirectPathFromUrl;
    }
    return path;
};
const isAllowedToUpdateTransitionStatusOf = (customer) => hasCustomerData(customer) && !isUserTransitioned(customer);
export const DeprecationWarning = (props) => {
    const { redirectPathOnClose, showModalOnLoad = true, deprecationScope = TRANSLATION_SCOPE, } = props;
    const [showModal, setShowModal] = useState(showModalOnLoad);
    const customer = useCustomerData({
        customerData: props.customer,
    });
    useEffect(() => {
        if (isAllowedToUpdateTransitionStatusOf(customer)) {
            updateUserAsTransitioned({
                isFashionStoreUser: isZalandoFashionStoreUser(customer),
                userRole: customer.role,
            });
        }
        if (isCookieFTWResetPasswordHasValueRecover()) {
            track(TrackEvent.TRACK_DATA, {
                generatedUrl: 'fb/deprecation/passwordResetSuccess',
            });
            deleteCookie(FTW_RESET_PASSWORD_SUCCESS_COOKIE);
        }
    }, [JSON.stringify(customer)]);
    if (!hasCustomerData(customer)) {
        return null;
    }
    const isFbUserTransitioned = isFacebookUser(customer) && isUserTransitioned(customer);
    const isFashionStoreUser = isZalandoFashionStoreUser(customer);
    const isLoungeUserNotTransitioned = !isFbUserTransitioned && !isFashionStoreUser;
    if (shouldHideModalOnPageLoad(showModal) ||
        !isFacebookUser(customer) ||
        doNotRenderIfNonTransitionedFacebookUserOfLoungeClosedModal(isLoungeUserNotTransitioned)) {
        return null;
    }
    return (React.createElement(TranslateScope, { path: `deprecationWarningOverlay.${deprecationScope}` },
        React.createElement(DeprecationWarningOverlay, { ...props, customer: customer, redirectPathOnClose: getRedirectionUrlPath(redirectPathOnClose), setShowModal: setShowModal, showModal: showModal, isFbUserTransitioned: isFbUserTransitioned, isFashionStoreUser: isFashionStoreUser })));
};
//# sourceMappingURL=DeprecationWarning.js.map